import { ApiService } from './ApiService';
import { DeviceDetect } from '../utils/DeviceDetect';
import { Router } from '../router/Router';

/**
 * Handle the Report Service.
 */
export class ReportService {
  /**
   * Send the error report to the api.
   *
   * @param  {object} err - The err object.
   * @returns {Promise} The promise of the sent probe.
   */
  static sendError(err) {
    const errorToReport = {
      message: err.message,
      columnNumber: err.columnNumber,
      fileName: err.fileName,
      lineNumber: err.lineNumber,
      path: Router.currentRoute,
      stack: err.stack,
    };

    return ApiService.makeRequest({
      url: ApiService.apiSchema.report.error.url,
      method: ApiService.apiSchema.report.error.method,
      body: {
        error: errorToReport,
        ontouch: DeviceDetect.isTouch(),
        resolution: `${window.innerWidth}x${window.innerHeight}`,
      },
    }, true)
      .catch(() => undefined);
  }
}
